/** Layout do cartaz de QR (check-in) do Clube de Mesa. */
import { PUBLIC_MEDIA } from '../../../../branding/assets';

export const QR_CHECKIN_API_SIZE = 420;

export const QR_DISPLAY_TEMPLATE = {
  backgroundUrl: PUBLIC_MEDIA.clubeQrDisplayFoodstation,
  rotation: '10.38deg',
  size: { width: '16.67%', height: '11.79%' },
  placements: [
    { left: '14.05%', top: '32.04%' },
    { left: '64.13%', top: '32.04%' },
    { left: '35.83%', top: '67.85%' },
    { left: '85.91%', top: '67.85%' },
  ],
};
